module.exports = __webpack_public_path__ + "static/img/grade_9.252e5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_9.png
// module id = sXZp
// module chunks = 89